module.exports = __webpack_public_path__ + "static/wfp-6ca8e4043c12e485a92117793a2407c0.mp4";